module.exports = __webpack_public_path__ + "media/images/fanclub/merit-chara-03@2x-0bf6827f76b044568ca010b679f09637.png";